export const INIT_PRC = "INIT_PRC";

export function initCategories(data) {
    return { type: INIT_PRC, data }
};



// WEBPACK FOOTER //
// ./src/services/store/reducers/productcategories/actions.js